export default __webpack_public_path__ + "static/media/step2.bd6d9bc8.mov";